<template>
  <TemplatesEditorTemplate type="client" />
</template>

<script>
import TemplatesEditorTemplate from "@/app/imports/components/templates/TemplatesEditorTemplate.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    TemplatesEditorTemplate,
  },
});
</script>
